import React from "react";
import { RouteObject } from "react-router-dom";
import routePaths from "./../../constants/routes";
// import Contact from "";
import ProtectedRoutes from "utils/ProtectedRoutes";
import Loader from "components/UI/Loader";

const Contact = React.lazy(() => import("./../../pages/Contact"));

export const contactRoutes: RouteObject[] = [
	{
		path: routePaths.CONTACT.__PATH,
		element: (
			<ProtectedRoutes>
				<React.Suspense fallback={<Loader />}>
					<Contact />
				</React.Suspense>
			</ProtectedRoutes>
		),
	},
];
